import React from 'react';
import styles from './CheckList.module.css';

export default function CheckList({ titulo, items, tipo }) {
  const isAlerta = tipo === 'alerta';

  return (
    <div className={`${styles.card} ${isAlerta ? styles.alertaCard : styles.positivoCard}`}>
      <div className={styles.titulo}>{titulo}</div>
      {items.length === 0 ? (
        <span className={styles.vazio}>Nenhum</span>
      ) : (
        <ul className={styles.lista}>
          {items.map((item, i) => (
            <li key={i} className={styles.item}>
              <span className={styles.icon}>{isAlerta ? '⚠️' : '✔'}</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
